import React from "react"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { RootState } from "../../../../../app/store"
import DialogTitle from "@mui/material/DialogTitle"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import Button from "@mui/material/Button"
import GroupIcon from "@mui/icons-material/Group"
import { DialogActions, Grid, Stack, Typography } from "@mui/material"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { setInterviewModeState, setInterviewRowState } from "./model/Interviews"

const InterviewsDialog = ({ open, setOpen }: any) => {
  const dispatch = useDispatch()
  const interviewGroup = useSelector((state: RootState) => state.interviewGroup)

  return (
    <Dialog
      sx={{
        ".MuiDialog-paper": {},
        ".MuiDialogContent-root": {},
        ".MuiDialogActions-root": { px: "24px", pb: "40px" },
      }}
      maxWidth={"lg"}
      open={open.openInterviewsDialog}
      onClose={() => setOpen({ ...open, openInterviewsDialog: false })}
      keepMounted
    >
      <DialogTitle sx={{ fontWeight: "bold", mt: "20px" }}>
        Групповое собеседование
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Typography fontWeight={400} fontSize={16} sx={{ mb: "16px" }}>
            {/* {interviewGroup &&
              `${dayjs(interviewGroup.data?.[0]?.interviewDateTime).format(
                "DD.MM.YYYY",
              )} в ${dayjs(interviewGroup.data?.[0]?.interviewDateTime).format(
                "HH.mm",
              )}`} */}
          </Typography>
          <Grid
            container
            sx={{
              border: "1px solid rgba(23, 23, 23, 0.2)",
              borderRadius: "4px",
              maxWidth: "1016px",
            }}
          >
            {interviewGroup.data.map((interview: any) => (
              <Grid
                key={interview.id}
                item
                sx={{
                  m: "10px",
                  bgcolor: "background.default",
                  p: "15px",
                  borderRadius: "4px",
                }}
              >
                <Stack
                  sx={{ width: "288px" }}
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography fontSize={14} fontWeight={500}>
                    {interview.personalInformation.fullName}
                  </Typography>
                  <Button
                    onClick={() => {
                      dispatch(setInterviewRowState(interview))
                      setOpen({ ...open, openInterviewsDialog: false })
                      setOpen({ ...open, openCreateInterwiew: true })
                      dispatch(setInterviewModeState({ mode: "edit" }))
                    }}
                    size="small"
                    sx={{
                      maxWidth: "25px !important",
                      maxHeight: "25px !important",
                      minWidth: "0px !important",
                      minHeight: "0px !important",
                    }}
                    variant="outlined"
                  >
                    <GroupIcon fontSize="small" />
                  </Button>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </DialogContent>{" "}
      <DialogActions>
        <Button
          onClick={() => setOpen({ ...open, openInterviewsDialog: false })}
          size="large"
          sx={{ fontWeight: "bold" }}
          variant="contained"
          type="submit"
        >
          Назад
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default InterviewsDialog
